/**
 * Configuración de redes para el sistema de transacciones
 *
 * TODAS las redes EVM usan el proxy del servidor (/api/proxy/explorer)
 * con la misma API Key del grupo Etherscan (BSCScan, Etherscan, Polygonscan, etc.)
 * manteniendo las keys fuera del browser.
 *
 * OMDB usa su propio explorer (omdbscan.com).
 * GLAK usa RPC genérico (sin historial de transacciones de explorer).
 */

import { NetworkConfig } from '@/types/transaction.types';
import { OMDB_CHAIN_ID } from './networks';

export const TRANSACTION_NETWORKS: Record<string, NetworkConfig> = {
  ethereum: {
    name: 'Ethereum',
    chainId: 1,
    providerType: 'alchemy',
    alchemyKey: import.meta.env.VITE_ALCHEMY_KEY_ETHEREUM,
  },
  polygon: {
    name: 'Polygon',
    chainId: 137,
    providerType: 'alchemy',
    alchemyKey: import.meta.env.VITE_ALCHEMY_KEY_POLYGON,
  },
  arbitrum: {
    name: 'Arbitrum',
    chainId: 42161,
    providerType: 'alchemy',
    alchemyKey: import.meta.env.VITE_ALCHEMY_KEY_ARBITRUM,
  },
  optimism: {
    name: 'Optimism',
    chainId: 10,
    providerType: 'alchemy',
    alchemyKey: import.meta.env.VITE_ALCHEMY_KEY_OPTIMISM,
  },
  bsc: {
    name: 'BSC',
    chainId: 56,
    providerType: 'alchemy',
    alchemyKey: import.meta.env.VITE_ALCHEMY_KEY_BSC,
  },
  omdb: {
    name: 'OMDB',
    chainId: OMDB_CHAIN_ID,
    providerType: 'explorer',
    explorerApiUrl: import.meta.env.VITE_OMDB_API_URL,
    rpcUrl: import.meta.env.VITE_OMDB_RPC_URL,
  },
  // glak: {
  //   name: 'GLAK Testnet',
  //   chainId: 35039980,
  //   providerType: 'rpc',
  //   rpcUrl: 'http://158.69.203.100:8545',
  // },
};

// ALCHEMY_NETWORKS ya no se usa para transacciones (se eliminó la dependencia de Alchemy)
// Se mantiene por si se necesita para otras funciones en el futuro.
export const ALCHEMY_NETWORKS: Record<string, string> = {
  ethereum: 'eth-mainnet',
  polygon: 'polygon-mainnet',
  arbitrum: 'arb-mainnet',
  optimism: 'opt-mainnet',
  bsc: 'bnb-mainnet',
};

export const SYNC_CONFIG = {
  INTERVAL: 60000, // 1 minuto
  PENDING_INTERVAL: 30000, // 30 segundos para transacciones pendientes
  INACTIVE_INTERVAL: 5 * 60 * 1000, // 5 minutos para wallet inactiva
  CACHE_TTL: parseInt(import.meta.env.VITE_TRANSACTION_CACHE_TTL) || 45000,
  REQUEST_TIMEOUT: parseInt(import.meta.env.VITE_TRANSACTION_TIMEOUT) || 5000,
};